import { Space, Typography } from 'antd';
import _ from 'lodash';
import { Plus } from 'lucide-react';

const { Text } = Typography;

/** Хавсралт оруулах нүдний хэмжээ */
export const TILE_SIZE = 104;

const tileStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 4,
  width: TILE_SIZE,
  height: TILE_SIZE,
  border: '1px dashed #d0d5dd',
  borderRadius: 8,
  backgroundColor: '#fafafa',
  color: '#667085',
  cursor: 'pointer',
  transition: 'border-color 0.12s ease, background-color 0.12s ease',
};

/**
 * Хавсралтын нүд — сонгоогүй бол тасархай хүрээтэй "+", сонгосон бол зураг
 * (эсвэл PDF)-ийн урьдчилсан харагдац.
 *
 * Хэрэглэдэг дэлгэцүүд:
 *   - views/request/Steps/Step1 (Бүртгэлийн 1-р алхам)
 *   - views/request/CitizenForm, OrganizationForm (Бизнес нэмэх)
 */
const UploadTile = ({ file }) => {
  if (!file) {
    return (
      <div style={tileStyle}>
        <Plus size={20} />
        <span style={{ fontSize: 12 }}>Хавсаргах</span>
      </div>
    );
  }

  const src = URL.createObjectURL(file);
  const isPdf = file?.type === 'application/pdf';

  return (
    <Space size={12} align="center" style={{ ...tileStyle, width: 'auto', padding: 8 }}>
      {isPdf ? (
        <embed src={src} style={{ width: TILE_SIZE - 24 }} />
      ) : (
        <img
          src={src}
          alt="Хавсаргасан зураг"
          style={{ width: TILE_SIZE - 24, borderRadius: 6, objectFit: 'contain' }}
        />
      )}
      <Text style={{ fontSize: 12 }}>{_.truncate(file?.name, { length: 13 })}</Text>
    </Space>
  );
};

export default UploadTile;
